import React from 'react';
// import { OrderItem } from '../../types';
import { BsX } from 'react-icons/bs';
import { OutboundOrderItem } from '../../../../api/warehouse/generated/src';

interface SerialModalProps {
  item: OutboundOrderItem;
  serialInput: string;
  onSerialInputChange: (value: string) => void;
  onAddSerial: () => void;
  onRemoveSerial: (serialId: string) => void;
  onConfirm: () => void;
  onClose: () => void;
}

export const SerialModal: React.FC<SerialModalProps> = ({
  item,
  serialInput,
  onSerialInputChange,
  onAddSerial,
  onRemoveSerial,
  onConfirm,
  onClose,
}) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg max-w-md w-full p-6 max-h-[90vh] overflow-y-auto">
        <h3 className="text-lg md:text-xl font-bold mb-2">Seriennummern erfassen</h3>
        <p className="text-gray-700 mb-4 text-sm md:text-base">{item.description}</p>
        
        <div className="mb-4">
          <p className="text-sm font-semibold mb-2">
            {item.serialNumbers?.length || 0} von {item.requiredQty - item.shippedQty} erfasst
            {item.shippedQty > 0 && (
              <span className="text-blue-600 ml-2">({item.shippedQty} bereits verschickt)</span>
            )}
          </p>
          <div className="w-full bg-gray-200 rounded-full h-2">
            <div 
              className="bg-purple-600 h-2 rounded-full transition-all"
              style={{ width: `${((item.serialNumbers?.length || 0) / (item.requiredQty - item.shippedQty)) * 100}%` }}
            />
          </div>
        </div>
        
        <div className="flex gap-2 mb-4">
          <input
            type="text"
            value={serialInput}
            onChange={(e) => onSerialInputChange(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && serialInput.trim()) {
                onAddSerial();
              }
            }}
            placeholder="Seriennummer eingeben oder scannen"
            className="flex-1 p-2 border rounded"
            autoFocus
          />
          <button
            onClick={onAddSerial}
            disabled={!serialInput.trim()}
            className="bg-purple-600 text-white px-4 py-2 rounded font-semibold hover:bg-purple-700 transition disabled:bg-gray-300"
          >
            Hinzufügen
          </button>
        </div>
        
        {item.serialNumbers && item.serialNumbers.length > 0 && (
          <div className="mb-4 space-y-2">
            <p className="text-sm font-semibold">Erfasste Seriennummern:</p>
            {item.serialNumbers.map(sn => (
              <div key={sn.number} className="flex items-center justify-between p-2 bg-purple-50 rounded">
                <span className="text-sm">{sn.number}</span>
                <button
                  onClick={() => onRemoveSerial(sn.number)}
                  className="text-red-600 hover:text-red-800"
                >
                  <BsX size={18} />
                </button>
              </div>
            ))}
          </div>
        )}
        
        <button
          onClick={onClose}
          className="w-full bg-gray-300 text-gray-800 py-2 px-4 rounded-lg font-semibold hover:bg-gray-400 transition"
        >
          {item.serialNumbers?.length === (item.requiredQty - item.shippedQty) ? 'Abschließen' : 'Abbrechen'}
        </button>
        
        {item.serialNumbers && item.serialNumbers.length > 0 && item.serialNumbers.length < (item.requiredQty - item.shippedQty) && (
          <button
            onClick={onConfirm}
            className="w-full mt-2 bg-orange-400 text-white py-2 px-4 rounded-lg font-semibold hover:bg-orange-500 transition"
          >
            ✓ Teilmenge bestätigen ({item.serialNumbers.length} von {item.requiredQty - item.shippedQty})
          </button>
        )}
      </div>
    </div>
  );
};